"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Link_1 = __importDefault(require("../Link/Link"));

var NavigationMenuItem_styles_1 = require("./NavigationMenuItem.styles");

var NavigationMenuItem =
/** @class */
function (_super) {
  __extends(NavigationMenuItem, _super);

  function NavigationMenuItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(NavigationMenuItem.prototype, "className", {
    get: function get() {
      var _a;

      var _b = this.props,
          classes = _b.classes,
          active = _b.active,
          dangerouslyApplyHoverStyle = _b.dangerouslyApplyHoverStyle;
      return classnames_1.default(classes.navigationItem, (_a = {}, _a[classes.active] = active, _a[classes.hover] = dangerouslyApplyHoverStyle, _a));
    },
    enumerable: false,
    configurable: true
  });

  NavigationMenuItem.prototype.render = function () {
    var _a = this.props,
        classes = _a.classes,
        href = _a.href,
        text = _a.text,
        onClick = _a.onClick,
        testId = _a.testId,
        restProps = __rest(_a, ["classes", "href", "text", "onClick", "testId"]);

    return react_1.default.createElement("div", {
      className: this.className,
      "data-test-id": testId,
      onClick: onClick
    }, react_1.default.createElement(Link_1.default, __assign({
      href: href,
      testId: "item-link",
      inherit: true
    }, restProps), react_1.default.createElement("div", {
      className: classes.navigationItemBody
    }, react_1.default.createElement("span", {
      className: classes.text,
      "data-test-id": "item-text"
    }, text), react_1.default.createElement("div", {
      className: classes.borderRight
    }))));
  };

  NavigationMenuItem = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(NavigationMenuItem_styles_1.styles)], NavigationMenuItem);
  return NavigationMenuItem;
}(react_1.default.PureComponent);

exports.default = NavigationMenuItem;